<div class="sidenav" [ngClass]="{ deployed: isDeployed && hasSubMenu }">
  <div class="menu-container row" style="margin-left: 0px; margin-right: 0px">
    <div class="nav-rail">
      <div class="nav-scroll">
        <ul class="left-menu">
          <ng-container *ngFor="let group of groupedMenuView; trackBy: trackByGroup">
            <li class="menu-group-label">{{ group.label | translate }}</li>
            <li *ngFor="let item of group.items; trackBy: trackByMenu" [routerLink]="item.siteMapUrl" routerLinkActive="active" (click)="loadMenuConfig(item)">
              <mat-icon [svgIcon]="item.icon"></mat-icon>
              <span class="menu-label">{{ item.label | translate }}</span>
            </li>
          </ng-container>
        </ul>
      </div>
      <a class="navbar-deployer" *ngIf="hasSubMenu" (click)="deployNavbar()">
        <mat-icon>{{ !isDeployed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
      </a>
    </div>
    <div class="sub-menu" [style.display]="isDeployed && hasSubMenu ? 'block' : 'none'">
      <app-list-user-entity *ngIf="this.router.url.split('/')[1] == SiteMapUrl.MenuUserEntity" [memberId]="perimeterId"> </app-list-user-entity>
      <ressource-list *ngIf="ressourceListConfig" [config]="ressourceListConfig" [attr.data-refresh]="configRefreshKey"> </ressource-list>
    </div>
  </div>
</div>
